import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  paginationFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 8,
    marginTop: 20,
    marginBottom: 48,
  },
  navBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 32,
    height: 32,
    padding: 0,
    border: 'none',
    background: 'transparent',
    color: '#0E1247',
    cursor: 'pointer',
    '&:hover:not(:disabled)': {
      opacity: 0.7,
    },
    '&:disabled': {
      opacity: 0.3,
      cursor: 'default',
    },
    '& svg': {
      fontSize: 22,
    },
  },
  pageBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 32,
    height: 32,
    padding: '0 6px',
    border: 'none',
    borderRadius: 6,
    background: 'transparent',
    color: '#0E1247',
    fontFamily: 'Poppins',
    fontSize: 16,
    fontWeight: 500,
    lineHeight: 1,
    cursor: 'pointer',
    '&:hover:not($pageBtnActive)': {
      backgroundColor: '#F3F4F8',
    },
  },
  pageBtnActive: {
    backgroundColor: '#000a8c1a',
    color: '#000A8C',
    cursor: 'default',
  },
});
